import './index.scss'

import { Collapse } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router'

import detailCoupon from '@/home/src/assets/imgs/detailCoupon.png'
import { EtaTag } from '@/home/src/pages/Detail/components/MarketingText'
import { CartReturnType, CouponResult } from '@api/home/shopCart/types'
import useCoupon from '@api/home/shopCart/useCoupon'
import { Flex, Gap, Grid, Icon, Image, Switch, Text, Title } from '@ui-pc'
import { getRelativeUrl, loTrack } from '@utils'
import { Knife, Type } from '@utils/tool'

import { showEstPoup } from '../CartList/ShopEmty'
import Coupon, { CouponInput } from '../Coupon'

const { map, concat } = Knife

type Props = {
  hideCoupon?: boolean
  headerSlot?: React.ReactNode
  button?: React.ReactNode
  shopListTotalInfo: CartReturnType
  onChange?: (result: CouponResult) => any
  shopList: CartReturnType['blockList'][number]
  isCartPage?: boolean
  hideTitle?: boolean
}

export const SkuOptionsText = (props: { attrs: any[] }) => {
  const { attrs } = props

  return (
    <Switch either={attrs?.length > 0}>
      <>
        {attrs?.map((data, index) => {
          return (
            <span key={[index, data.productsOptionsName].join('')}>
              <span className="sku-op-text">{data.productsOptionsName}</span>
              <span className="sku-op-text">{': '}</span>
              <span className="sku-op-text">
                {data.productsOptionsValuesName}
              </span>
              <Switch either={index < attrs.length - 1}>
                <span className="sku-op-text" style={{ margin: '0 2px' }}>
                  /
                </span>
              </Switch>
            </span>
          )
        })}
      </>
    </Switch>
  )
}

export const CartLiStThumbnail = (props: {
  totalAmount?: string
  productList: Props['shopList']['productList']
  jumpTo?: boolean
  isCartPage?: boolean
}) => {
  const { productList = [], totalAmount, jumpTo, isCartPage } = props
  const [isShowNail, useShow] = React.useState(false)
  const navigate = useNavigate()

  // 计算加购数量
  let sum = productList.reduce(
    (accumulator, current) => accumulator + Number(current?.qty || 0),
    0
  )

  return (
    <Switch either={!Type.isEmpty(productList)}>
      <Flex id="cartlist-thumbnail">
        <Collapse
          defaultActiveKey={'1'}
          bordered={false}
          expandIconPosition="end"
          expandIcon={(panelProps) => (
            <i
              className={`iconfont icon-m_ic_jiantou ${
                !isShowNail && 'show-open-icon'
              }`}></i>
          )}
          onChange={() => {
            useShow(!isShowNail)
          }}
          items={
            isCartPage
              ? null
              : [
                  {
                    key: '1',
                    label: (
                      <Switch either={!Type.isNever(totalAmount)}>
                        <Title level={4} className="cart-title right-title">
                          Cart Summary {`(${sum} item${sum > 1 ? 's' : ''})`}
                        </Title>
                        <Title level={4} className="cart-title right-title">
                          Summary
                        </Title>
                      </Switch>
                    ),
                    extra: (
                      <Title level={4} className="cart-title right-title">
                        {totalAmount}
                      </Title>
                    ),
                    children: map(productList, (item) => {
                      return (
                        <div
                          style={jumpTo ? { cursor: 'pointer' } : {}}
                          onClick={() => {
                            jumpTo && navigate(getRelativeUrl(item.url))
                          }}
                          key={item.skuId}
                          className="pro-item">
                          <div className="pro-item-img">
                            <Image
                              placeholder
                              preview={false}
                              alt={item.productsName}
                              src={item.imageUrl}
                              width="100%"
                              height="100%"
                            />
                          </div>
                          <div className="pro-item-right">
                            <div className="pro-mid">
                              {/* 标题 */}
                              <div className="pro-name">
                                {item.productsName}
                              </div>
                              {/* sku信息1  */}
                              <div className="pro-attrs">
                                <SkuOptionsText attrs={item?.attrs} />
                              </div>
                            </div>
                            <div className="pro-bottom">
                              <div className="pro-price">
                                <span className="pro-price-1">
                                  {item?.formatFinalPrice}
                                </span>
                                <span className="pro-price-2">
                                  {item?.formatMarketPrice}
                                </span>
                              </div>
                              <span className="pro-qty">
                                {concat('x', ' ', item.qty)}
                              </span>
                            </div>
                            <EtaTag productInfo={item} className="eta-tag" />
                          </div>
                        </div>
                      )
                    })
                  }
                ]
          }
          style={{
            width: '100%',
            background: 'none'
          }}
        />
        {!isCartPage && isShowNail && (
          <Grid
            direction="column"
            gap={[10, 8]}
            justifyContent="flex-start"
            className="scroll-imgs">
            {map(productList?.slice(0, 5), (data) => {
              return (
                <Icon
                  style={{ width: 68, height: 68 }}
                  key={data.skuId}
                  src={data.imageUrl}
                />
              )
            })}
          </Grid>
        )}
      </Flex>
    </Switch>
  )
}

export const TaxInfo = (props: { shopListTotalInfo }) => {
  const { shopListTotalInfo } = props

  return (
    <Switch either={!Type.isEmpty(shopListTotalInfo?.taxInfo)}>
      <>
        <div className="sidebar-item-flex" style={{ paddingTop: 24 }}>
          <span
            className=""
            onClick={() => {
              showEstPoup()
            }}>
            Est. Tax
            <Icon
              customSrc="icon-pc_wenhao est-question"
              style={{ color: '#999999', cursor: 'pointer' }}
            />
          </span>
          <span className="sidebar-item-title">
            {shopListTotalInfo?.taxInfo?.taxTotalFormat}
          </span>
        </div>
        <Flex padding={[0, 24]}>
          <p style={{ fontSize: 12 }}>{shopListTotalInfo?.taxInfo?.taxDesc}</p>
        </Flex>
      </>
    </Switch>
  )
}

export const Discount = (props) => {
  const { shopListTotalInfo = {} } = props

  const [lower, setState] = React.useState(true)

  const details = shopListTotalInfo.discountList ?? []

  return (
    <Switch either={shopListTotalInfo.discountSize}>
      <div className="item-border" style={{ width: '100%' }}>
        <div
          className="item-flex "
          onClick={() => {
            setState(!lower)
          }}>
          <span className="item-title">Discount</span>
          <p>
            <span className="item-title item-red">
              {shopListTotalInfo.promoDiscount
                ? `-${shopListTotalInfo.promoDiscount}`
                : '$0'}
            </span>
            {lower ? (
              <i className="iconfont icon-PC_lower icon-14" />
            ) : (
              <i className="iconfont icon-PC_upper icon-14" />
            )}
          </p>
        </div>
        <Switch either={!lower}>
          <Flex paddingLeft={12} rowGap={8} paddingBottom={0}>
            {details.map((data, index) => {
              return (
                <Flex
                  justify="space-between"
                  key={index}
                  paddingBottom={details.length - 1 === index ? 12 : 0}>
                  <span className="stats-coupon-details">{data.name}</span>
                  <span className="stats-coupon-details">
                    {data.discountPrice}
                  </span>
                </Flex>
              )
            })}
          </Flex>
        </Switch>
      </div>
    </Switch>
  )
}

/**
 * 结算右侧统计面板
 */
export const StatisticalPanel = (props: Props & { shopGroupList?: any }) => {
  const {
    button,
    hideCoupon,
    shopListTotalInfo,
    shopList,
    shopGroupList,
    onChange,
    isCartPage,
    hideTitle = false
  } = props

  const handler = useCoupon({
    shopListTotalInfo,
    onChange
  })

  return (
    <div className="card-style">
      <Flex alignItems="center">
        <Switch either={!hideTitle}>
          <div className="head-title">Order Summary</div>
        </Switch>
        <CartLiStThumbnail
          totalAmount={shopGroupList?.formatItemTotalAmount}
          productList={shopList?.productList}
          isCartPage={isCartPage}
        />
        <div className="item-flex sub-title">
          <span className="item-title">Subtotal</span>
          <span className="item-title item-line">
            {shopListTotalInfo.totalMarketPrice}
          </span>
        </div>
        <Discount shopListTotalInfo={shopListTotalInfo} />
        <div className="item-flex item-subtotal">
          <span className="item-title">{''}</span>
          <span className="item-title ib">{shopListTotalInfo.subtotal}</span>
        </div>
      </Flex>
      <Switch either={!hideCoupon}>
        <>
          <div
            className="item-flex item-coupon"
            onClick={() => {
              handler.setOpen(true)
              !!button ? loTrack('Cart_Coupon') : loTrack('Checkout_Coupon')
            }}
            style={{ cursor: 'pointer' }}>
            <span className="item-title">
              <Icon src={detailCoupon} className="ap-icon" />
              {/* Apply Coupon */}
            </span>
            <div className="item-title item-coupon-icon">
              <Switch either={!!shopListTotalInfo?.appleCouponDesc}>
                <span className={'coupon-savings'}>
                  {shopListTotalInfo?.appleCouponDesc}
                </span>
              </Switch>
              <i className="iconfont icon-m_ic_jiantou icon-14 "></i>
            </div>
          </div>
          <div className="coupon-input-box">
            <CouponInput
              loading={handler.isLoading}
              onChange={handler.onInputChange}
              onApply={handler.onApply}
            />
          </div>
        </>
      </Switch>
      <Switch either={shopListTotalInfo?.showShippingFee}>
        <Flex padding={[16, 0]} justify="space-between">
          <span className="item-title">Shipping Fee</span>
          <span className="item-title sf-price">
            {shopListTotalInfo?.formatShippingFee || '$0'}
          </span>
        </Flex>
      </Switch>
      <Switch either={isCartPage}>
        <Switch either={!Type.isEmpty(shopListTotalInfo?.taxInfo)}>
          <Flex padding={[0, 0]} justify="space-between">
            <span
              className="item-title"
              onClick={() => {
                showEstPoup()
              }}>
              Est. Tax
              <Icon
                customSrc="icon-ask est-question"
                style={{ color: '#999999', cursor: 'pointer' }}
              />
            </span>
            <span className="item-title sf-price">
              {shopListTotalInfo?.taxInfo?.taxTotalFormat}
            </span>
            <Flex padding={[6, 0]}>
              <p style={{ fontSize: 12 }}>
                {shopListTotalInfo?.taxInfo?.taxDesc}
              </p>
            </Flex>
          </Flex>
        </Switch>
        <Flex padding={[0, 0]} justify="space-between">
          <span
            className="item-title"
            onClick={() => {
              showEstPoup()
            }}>
            {shopListTotalInfo?.totalPre}Tax
            <Icon
              customSrc="icon-ask est-question"
              style={{ color: '#999999', cursor: 'pointer' }}
            />
          </span>
          <span className="item-title sf-price">
            {shopListTotalInfo?.formatTaxTotal}
          </span>
        </Flex>
      </Switch>
      <div className="item-flex item-total-box">
        <Text className="total-title">{shopListTotalInfo?.totalPre}Total</Text>
        <Text strong className="total-title">
          {shopListTotalInfo.grandTotal}
        </Text>
      </div>
      <Flex id="pay-button">{button}</Flex>
      <Coupon {...handler} />
    </div>
  )
}
